export const colors = {
    primary: "#A92216",
    secondary: "#EA2333",
    tertiary: "#FFFFFF"
}